<template>
  <path
    d="M7 14H9V12H7V14ZM8 2C5.79 2 4 3.79 4 6H6C6 4.9 6.9 4 8 4C9.1 4 10 4.9 10 6C10 8 7 7.75 7 11H9C9 8.75 12 8.5 12 6C12 3.79 10.21 2 8 2Z"
  />
</template>
